/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRuler2 = createReactComponent("outline", "ruler-2", "IconRuler2", [["path", { "d": "M17 3l4 4l-14 14l-4 -4z", "key": "svg-0" }], ["path", { "d": "M16 7l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M13 10l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M10 13l-1.5 -1.5", "key": "svg-3" }], ["path", { "d": "M7 16l-1.5 -1.5", "key": "svg-4" }]]);

export { IconRuler2 as default };
//# sourceMappingURL=IconRuler2.mjs.map
